var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"joy"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"joy-container"},[_c('div',{ref:"editor",staticClass:"joy-editor"})])])}
var staticRenderFns = []

export { render, staticRenderFns }